var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1256"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1256"
    },
    "bundlingPackage": "feedback-public-submission-ui",
    "bundlingPackageVersion": "static-1.30818",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};